import React from "react";

export const SyncForExpensesIcon: React.FC = () => {
  return (
    <svg
      data-testid="sync-for-expenses-icon"
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_1530_2105)">
        <g clipPath="url(#clip0_1530_2105)">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="#70C1FF" />
          <rect
            x="35.1211"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 35.1211 2)"
            fill="#194185"
          />
          <rect
            x="38.6719"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 38.6719 2)"
            fill="#194185"
          />
          <rect
            x="31.5703"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 31.5703 2)"
            fill="#194185"
          />
          <rect
            x="24.4727"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 24.4727 2)"
            fill="#194185"
          />
          <rect
            x="20.9219"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 20.9219 2)"
            fill="#194185"
          />
          <rect
            x="17.3711"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 17.3711 2)"
            fill="#194185"
          />
          <rect
            x="51"
            y="34.127"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 34.127)"
            fill="#194185"
          />
          <rect
            x="51"
            y="37.6758"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 37.6758)"
            fill="#194185"
          />
          <rect
            x="51"
            y="30.5762"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 30.5762)"
            fill="#194185"
          />
          <rect
            x="51"
            y="23.4766"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 23.4766)"
            fill="#194185"
          />
          <rect
            x="51"
            y="19.9258"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 19.9258)"
            fill="#194185"
          />
          <rect
            x="51"
            y="16.375"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 16.375)"
            fill="#194185"
          />
          <g filter="url(#filter1_di_1530_2105)">
            <rect
              x="7"
              y="6"
              width="40"
              height="40.0001"
              rx="6"
              fill="#1A0044"
            />
            <rect
              x="7.24859"
              y="6.24859"
              width="39.5028"
              height="39.5029"
              rx="5.75141"
              stroke="black"
              strokeOpacity="0.2"
              strokeWidth="0.49718"
            />
          </g>
          <g filter="url(#filter2_i_1530_2105)">
            <path
              d="M38.6654 23.6667H15.332M25.832 34.1667L34.932 34.1667C36.2388 34.1667 36.8922 34.1667 37.3914 33.9124C37.8304 33.6887 38.1874 33.3317 38.4111 32.8927C38.6654 32.3935 38.6654 31.7401 38.6654 30.4333V21.5667C38.6654 20.2599 38.6654 19.6065 38.4111 19.1074C38.1874 18.6683 37.8304 18.3114 37.3914 18.0877C36.8922 17.8333 36.2388 17.8333 34.932 17.8333H32.832M25.832 34.1667L28.1654 36.5M25.832 34.1667L28.1654 31.8333M21.1654 34.1667H19.0654C17.7586 34.1667 17.1052 34.1667 16.6061 33.9124C16.167 33.6887 15.8101 33.3317 15.5863 32.8927C15.332 32.3935 15.332 31.7401 15.332 30.4333V21.5667C15.332 20.2599 15.332 19.6065 15.5863 19.1074C15.8101 18.6683 16.167 18.3114 16.6061 18.0877C17.1052 17.8333 17.7586 17.8333 19.0654 17.8333H28.1654M28.1654 17.8333L25.832 20.1667M28.1654 17.8333L25.832 15.5"
              stroke="white"
              strokeWidth="1.7846"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <rect
          x="3.21818"
          y="2.21818"
          width="47.5636"
          height="47.5637"
          rx="7.78182"
          stroke="black"
          strokeOpacity="0.2"
          strokeWidth="0.436364"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_1530_2105"
          x="0.745718"
          y="0.497145"
          width="52.5086"
          height="52.5086"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.751427"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1530_2105"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="0.751427" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_2105"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="1.12714" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1530_2105"
            result="effect2_dropShadow_1530_2105"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1530_2105"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_di_1530_2105"
          x="3"
          y="3"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_2105"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1530_2105"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.99436" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1530_2105"
          />
        </filter>
        <filter
          id="filter2_i_1530_2105"
          x="13"
          y="12"
          width="28"
          height="28"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.0605682" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1530_2105"
          />
        </filter>
        <clipPath id="clip0_1530_2105">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
